<template>
  <el-select
    :value="value"
    size="small"
    @change="handleChange"
    placeholder="搜索并选择"
    style="width: 100%"
    filterable
    :clearable="clearable"
  >
    <el-option v-if="clearable" :key="0" label="不限" :value="0"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { itemTemplateList } from '@/service/getData'

export default {
  props: {
    value: '',
    category: {
      type: Number,
      default: 0,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      let res = await itemTemplateList({
        category: this.category,
        size: 200,
      })
      if (res.status == 0) {
        this.lists = res.data.list
      }
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>